import styled from 'styled-components';

export const RightAlignedDiv = styled.div`
  text-align: right;
`;
